/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) string table
   English is the source of truth in the HTML; this file supplies the
   German counterpart for each data-i18n key. Missing keys fall back to
   English automatically (see i18n.js). Hand this file to a translator or
   compliance reviewer; it is the single place German copy lives.

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal "du", never "Sie"
   for singular address. Standalone "serum" → "Serum".
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.de = Object.assign(window.TD_I18N.de || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Shop',
  'nav.science': 'Wissenschaft',
  'nav.concerns': 'Hautbedürfnisse',
  'nav.story': 'Unsere Geschichte',
  'nav.contact': 'Kontakt',
  'nav.tryus': 'Probier uns aus',
  'nav.faq': 'Häufige Fragen',
  'nav.drawerCta': 'Probier uns aus · Discovery Kit',
  'nav.drawerFine': 'Fünf Vitaminseren · $70 · weltweiter Versand',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Kostenloser Versand</strong> bei allen Bestellungen über $150',
  'announce.0b': 'Weltweiter Versand aus Stockholm',
  'announce.1a': '<strong>Stell eine Routine zusammen und spare 10%</strong>',
  'announce.1b': 'Automatisch an der Kasse angewendet',
  'announce.2a': 'Probier alle fünf Seren aus.',
  'announce.2b': '<strong>Kostenloser Versand ab $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Hautpflege ohne Kompromisse · Est. 1998',
  'home.hero.h1': '<span class="l1">Ohne Wasser.</span><br><span class="l2">Ohne Konservierungsstoffe.</span><br><span class="l3">Ohne Zusatzstoffe.</span><br><span class="l4">Ohne Farbstoffe.</span><br><span class="l5">Ohne Luft.</span><br><span class="l6"><em class="hero-vitamins-em">Nur aktive Vitamine.</em></span>',
  'home.hero.sub': 'Formuliert für echte Aufnahme in die Haut, weit unter die Oberfläche.<br>Fünf Vitaminseren. Fünf Nein. Ein System.',
  'home.hero.cta1': 'Seren entdecken',
  'home.hero.cta2': 'So funktioniert es',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': '<em>Sommer</em> 2026<br>Kampagne',
  'home.cs.shop': 'Seren jetzt erhältlich',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Gesehen in',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'Die Kollektion',
  'home.coll.h2': 'Präzise formulierte Vitaminseren. <em>Entwickelt in Stockholm.</em>',
  'home.coll.viewAll': 'Alle Produkte ansehen',
  'home.coll.c.benefit': 'Schützt, bringt zum Strahlen und festigt mit reinem Vitamin C.',
  'home.coll.a.benefit': 'Erneuerung mit Retinol, während du schläfst.',
  'home.coll.o.benefit': 'Belebt die Zellen und holt sichtbare Strahlkraft zurück.',
  'home.coll.m.benefit': 'Repariert die Feuchtigkeitsbarriere. Tief und nachhaltig.',
  'home.coll.r.benefit': 'Festigt und stellt wieder her. Reduziert mit der Zeit das Erscheinungsbild von Unreinheiten, Aknemalen und Texturunregelmäßigkeiten.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Alle fünf Seren im Reiseformat. Teste das ganze System, bevor du dich entscheidest.',
  'home.coll.kit.badge': 'Neu',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'Die Wissenschaft',
  'home.science.h2': 'Tiefe Penetration macht<br><em>den Unterschied.</em>',
  'home.science.body': 'Das Transportsystem von Transderma bringt aktive Vitamine über die Epidermis hinaus bis in die Dermis, dort wo Kollagensynthese und Zellerneuerung tatsächlich stattfinden.',
  'home.science.readMore': 'Die ganze Wissenschaft lesen →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Transderma<br>Seren',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Äußerste Schicht der Haut',
  'home.sci.l1.p': 'Das Stratum corneum ist die äußere Barriere der Haut: abgestorbene, dicht gepackte Zellen, die das meiste blockieren, was wir auftragen. Die wasserfreie Formel von Transderma zieht innerhalb von Sekunden nach dem Auftragen ein. Die aktiven Vitamine erreichen das lebende Gewebe darunter unversehrt, ohne Verlust durch Verdunstung.',
  'home.sci.l1.depth': '0 mm TIEFE',
  'home.sci.l2.label': 'EPIDERMIS',
  'home.sci.l2.desc': 'Lebende Hautzellen, Melanozyten, Nervenenden',
  'home.sci.l2.p': 'Die meisten Seren hören hier auf, abgelegt zwischen den lebenden Zellen der Epidermis, unfähig weiterzukommen. Transderma enthält kein Wasser, also behält jeder Tropfen seine volle Vitaminkonzentration während der Reise. Nichts wird unterwegs verdünnt; die Formel bewegt sich weiter zur Dermis.',
  'home.sci.l2.depth': '0,1 mm TIEFE',
  'home.sci.l2.stop': 'Die meisten Seren hören hier auf',
  'home.sci.barrier': 'HAUTBARRIERE',
  'home.sci.l3.label': 'DERMALE SCHICHT',
  'home.sci.l3.desc': 'Kollagen, Elastin, Fibroblasten, Blutgefäße',
  'home.sci.l3.p': 'Die Dermis ist der Ort, an dem die wirklich dauerhafte Veränderung der Haut geschieht: Kollagen, Elastin und Zellerneuerung beginnen hier. Transderma transportiert konzentrierte Vitamine direkt in diese Schicht, wo die Fibroblasten sie verwenden können. Das ist die Schicht, die herkömmliche Seren selten erreichen, und der Grund, warum unsere Ergebnisse über Wochen sichtbar werden.',
  'home.sci.l3.depth': '1–2 mm TIEFE',
  'home.sci.l4.label': 'SUBKUTANES GEWEBE',
  'home.sci.l4.desc': 'Fettgewebe und tiefe strukturelle Stütze',
  'home.sci.l4.p': 'Unter der Dermis liegt die subkutane Schicht, ein Fettgewebe, das die Haut verankert und ihre Form hält. In dieser Tiefe sind die Vitamine von Transderma bereits von der darüber liegenden Dermis aufgenommen worden. Das Gewebe hier ist die strukturelle Basis für die Erneuerung, die in jeder darüber aufgebauten Schicht stattfindet.',
  'home.sci.l4.depth': '4–10 mm TIEFE',
  'home.sci.reach': 'TRANSDERMA ERREICHT DIESE TIEFE',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'Der Unterschied',
  'home.purity.h2': 'Nicht das, was<br><em>du erwartest.</em>',
  'home.purity.water.title': 'Ohne Wasser',
  'home.purity.water.body': 'Wasserfreie Formel. Höhere Konzentration, tiefere Penetration.',
  'home.purity.preserv.title': 'Ohne Konservierungsstoffe',
  'home.purity.preserv.body': 'Ohne Wasser können sich keine Mikroben entwickeln. Es sind keine nötig.',
  'home.purity.fillers.title': 'Ohne Zusatzstoffe',
  'home.purity.fillers.body': 'Jeder Inhaltsstoff ist funktional. Keine Emulgatoren, Verdickungsmittel oder Massefüllstoffe.',
  'home.purity.dyes.title': 'Ohne Farbstoffe',
  'home.purity.dyes.body': 'Der Farbton, den du siehst, stammt von den rohen Wirkstoffen, nicht von zugesetzter Farbe.',
  'home.purity.air.title': 'Ohne Luft',
  'home.purity.air.body': 'Versiegelt in einer Airless-Pumpe. Volle Stärke, vom ersten bis zum letzten Tropfen.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Reine Formulierung',
  'home.strip.h3': 'Nur aktive Vitamine.<br><em>Sonst nichts.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Nie an Tieren getestet.</strong> Tierversuchsfrei vom ersten Tag an.',
  'home.trust.vegan': '<strong>Vegane Formulierungen.</strong> Keine Inhaltsstoffe tierischen Ursprungs.',
  'home.trust.made': '<strong>Hergestellt in Stockholm.</strong> Laborzugelassen von Läkemedelsverket.',
  'home.trust.eu': '<strong>In der EU als Kosmetik registriert.</strong> Verkauft in Kliniken in 14 Ländern.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Airless-Design',
  'home.airless.h2': 'Versiegelt vom ersten Pumpstoß<br><em>bis zum letzten.</em>',
  'home.airless.body': 'Luft ist das, was ein Serum altern lässt. Die Airless-Pumpe schließt diese Tür. Der letzte Tropfen hat dieselbe Stärke wie der erste.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': 'Du weißt nicht, wo du anfangen sollst?',
  'home.sample.h2': 'Probier alle fünf<br><em>für $70.</em>',
  'home.sample.body': 'Das Transderma Discovery Kit enthält Reiseformat-Versionen aller fünf Seren und einen gedruckten Leitfaden, um deine Routine zusammenzustellen. So haben uns die meisten unserer langjährigen Kunden zum ersten Mal entdeckt.',
  'home.sample.bodyTheme': 'Das Transderma Discovery Kit enthält Reiseformat-Versionen aller fünf Seren. So haben uns die meisten unserer langjährigen Kunden zum ersten Mal entdeckt.',
  'home.sample.cta': 'Discovery Kit holen',
  'home.sample.fine': '$5 Versand · Inklusive gedrucktem Leitfaden zu Hautbedürfnissen',
  'home.sample.fineTheme': '$5 weltweiter Versand · Versendet aus Stockholm',
  'home.sample.f1.h': 'Alle fünf Seren',
  'home.sample.f1.p': 'Reiseformat, perfekt für unterwegs. Etwa 7 Tage regelmäßige Anwendung.',
  'home.sample.f1.pTheme': '3-ml-Reiseformat-Flaschen, perfekt für unterwegs. Etwa 7 Tage regelmäßige Anwendung pro Flasche.',
  'home.sample.f2.h': 'Leitfaden zu Hautbedürfnissen',
  'home.sample.f2.p': 'Ein gedruckter Leitfaden, der dir hilft, die Seren zu finden, die zu deinen spezifischen Bedürfnissen passen.',
  'home.sample.f2.hTheme': 'Alle fünf, Seite an Seite',
  'home.sample.f2.pTheme': 'Teste jede Formel in derselben Woche in deiner Routine und finde die Kombinationen, die für deine Haut funktionieren.',
  'home.sample.f3.h': 'Keine Verpflichtung',
  'home.sample.f3.p': 'Finde heraus, ob Transderma das Richtige für dich ist. Die meisten wissen es in wenigen Tagen.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Finde deine Formel',
  'home.conc.h2': 'Einkaufen nach<br><em>deinen Hautbedürfnissen.</em>',
  'home.conc.firm.t': 'Festigkeit',
  'home.conc.firm.d': 'Verlust von Elastizität und Definition an Kieferpartie und Wangen.',
  'home.conc.bright.t': 'Strahlkraft',
  'home.conc.bright.d': 'Unebener Teint, fehlende Leuchtkraft und Verfärbungen durch Umwelteinflüsse, Narben oder Aknemalen.',
  'home.conc.hydrate.t': 'Feuchtigkeit',
  'home.conc.hydrate.d': 'Trockene Haut, Schuppung und geschwächte Feuchtigkeitsbarriere, die nicht mehr hält.',
  'home.conc.lines.t': 'Feine Linien',
  'home.conc.lines.d': 'Oberflächliche feine Linien und tiefere Mimikfalten, die sich mit der Zeit entwickeln.',
  'home.conc.viewAll': 'Alle Hautbedürfnisse ansehen →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Dozent</span>',
  'home.her.eyebrow': 'Der Gründer',
  'home.her.h2': 'Dreißig Jahre.<br><em>Dieselbe Formel.</em>',
  'home.her.body': 'Transderma entstand in einem Labor in Stockholm, gegründet von Dr. Klaus Alvin Ronlán nach fünfundzwanzig Jahren Forschung an der Universität Lund. Fünf Seren, lanciert 1998. Seit dem Tod von Dr. Ronlán im Jahr 2018 unverändert bewahrt. Bis heute unabhängig. Bis heute in Schweden hergestellt.',
  'home.her.bodyTheme': 'Transderma entstand in einem Labor in Stockholm, gegründet von Dr. Klaus Alvin Ronlán nach fünfundzwanzig Jahren Forschung. Bis heute unabhängig. Bis heute in Schweden hergestellt.',
  'home.her.cta': 'Lies die Geschichte von Dr. Ronlán →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Ausgezeichnet',
  'awards.serumC': 'Nordic Natural Beauty Awards · Gewinner 2020',
  'awards.serumA': 'Global Makeup Awards · Silver, Skandinavien 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Gewinner 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Gewinner 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Gewinner 2013',
  'awards.fullLine': 'Anerkannt von · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Anerkannt · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '«Hochwirksame Hautpflege auf höchstem Niveau.»',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '«Wie Magie für die Haut. Mein Pigmentproblem an der Oberlippe ist verschwunden.»',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '«Die Wissenschaft hinter diesem Produkt und die Schlichtheit der Formel sind beeindruckend.»',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '«Hautpflege auf höchstem Niveau. Transderma A und C.»',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Stockholm',
  'footer.location': 'Stockholm, Schweden',
  'footer.col.serums': 'Seren',
  'footer.col.shop': 'Shop',
  'footer.col.learn': 'Entdecken',
  'footer.col.support': 'Kundenservice',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Geschenkkarten',
  'footer.shop.all': 'Alle Seren',
  'footer.learn.research': 'Forschung von Dr. Ronlán',
  'footer.learn.science': 'Die Wissenschaft',
  'footer.learn.concerns': 'Hautbedürfnisse',
  'footer.learn.story': 'Unsere Geschichte',
  'footer.learn.about': 'Über Dr. Ronlán',
  'footer.support.faq': 'Häufige Fragen',
  'footer.support.shipping': 'Versand &amp; Rücksendungen',
  'footer.support.stockists': 'Verkaufsstellen',
  'footer.support.contact': 'Kontakt',
  'footer.support.privacy': 'Datenschutz',
  'footer.support.terms': 'AGB',
  'footer.copy': '© 2026 Transderma®. Alle Rechte vorbehalten. Stockholm, Schweden.<svg class="ft-flag" viewBox="0 0 5 3" xmlns="http://www.w3.org/2000/svg" aria-label="Deutschland"><rect width="5" height="1" y="0" fill="#000000"/><rect width="5" height="1" y="1" fill="#DD0000"/><rect width="5" height="1" y="2" fill="#FFCE00"/></svg>',
  'footer.links.privacy': 'Datenschutz',
  'footer.links.terms': 'AGB',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Zertifizierungen',
  'certifications.ewg': 'EWG Verifiziert',
  'certifications.certclean': 'CertClean Zertifiziert'

});
